import React from "react";
import AvatarBlock from "../atoms/AvatarBlock";

// Molecule: avatar + name/title + any extra "row" rendered under the title.
const TalentIdentity = ({ name, title, avatar, initials, online, children }) => (
  <div className="qp-card-top">
    <AvatarBlock avatar={avatar} initials={initials} online={online} name={name} />
    <div className="qp-card-info">
      <div className="qp-card-name">{name}</div>
      <div className="qp-card-title">{title}</div>
      {children}
    </div>
  </div>
);

export default TalentIdentity;

